// components/MobileSidebar.js
import { X, LogOut } from "lucide-react";

const MobileSidebar = ({ open, onClose, onLogout }) => {
  if (!open) return null;

  return (
    <div style={styles.overlay}>
      <div style={styles.sidebar}>
        
        <div style={styles.header}>
          <h3>Menu</h3>
          <X onClick={onClose} style={{ cursor: "pointer" }} />
        </div>

        <button onClick={onLogout} style={styles.logout}>
          <LogOut size={18}/> Logout
        </button>

      </div>
    </div>
  );
};

const styles = {
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    background: "rgba(0,0,0,0.4)",
    zIndex: 999,
  },
  sidebar: {
    width: "250px",
    height: "100%",
    background: "#fff",
    padding: "20px",
  },
  header: {
    display: "flex",
    justifyContent: "space-between",
    marginBottom: "20px",
  },
  logout: {
    padding: "12px",
    width: "100%",
    background: "#33AE54",
    color: "#fff",
    border: "none",
    borderRadius: "8px",
  },
};

export default MobileSidebar;